import React from "react";

import { useNavigate } from "react-router-dom";

const HomeVirtualTour = () => {
  const navigate =
    useNavigate();

  return (
    <section className="w-full bg-white py-20 overflow-x-hidden">

      <div className="max-w-7xl mx-auto px-5 md:px-10">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* LEFT CONTENT */}
          <div>

            {/* BADGE */}
            <span className="inline-block bg-[#0B4F9C]/10 text-[#0B4F9C] px-5 py-2 rounded-full text-sm font-semibold tracking-wide">

              Explore Campus Digitally

            </span>

            {/* TITLE */}
            <h2 className="text-4xl md:text-6xl font-extrabold text-[#072F5F] leading-tight mt-6">

              Virtual Tour
              <span className="block text-[#0B4F9C]">
                Of School
              </span>

            </h2>

            {/* DESCRIPTION */}
            <p className="text-gray-600 text-lg leading-9 mt-8">

              Step inside our beautiful campus through an
              immersive 360° virtual experience. Explore
              classrooms, library, playground, activity
              zones and modern learning spaces from
              anywhere.

            </p>

            <p className="text-gray-600 text-lg leading-9 mt-6">

              Discover the environment where learning,
              creativity and growth happen every day.
              Parents and students can walk through the
              campus online before visiting physically.

            </p>

            {/* LIST */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">

              <div className="bg-[#f7f9fc] rounded-2xl p-5 border border-gray-100 shadow-sm">

                <h3 className="font-semibold text-[#072F5F]">

                  360° Smart Campus Experience

                </h3>

              </div>

              <div className="bg-[#f7f9fc] rounded-2xl p-5 border border-gray-100 shadow-sm">

                <h3 className="font-semibold text-[#072F5F]">

                  Explore Classrooms & Labs

                </h3>

              </div>

              <div className="bg-[#f7f9fc] rounded-2xl p-5 border border-gray-100 shadow-sm">

                <h3 className="font-semibold text-[#072F5F]">

                  Library & Playground View

                </h3>

              </div>

              <div className="bg-[#f7f9fc] rounded-2xl p-5 border border-gray-100 shadow-sm">

                <h3 className="font-semibold text-[#072F5F]">

                  Anytime, Anywhere Access

                </h3>

              </div>

            </div>

            {/* BUTTON */}
            <button
              className="mt-10 bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-8 py-4 rounded-2xl font-semibold text-lg shadow-lg hover:shadow-2xl transition-all duration-300"
              onClick={() =>
                navigate(
                  "/virtual-tour"
                )
              }
            >

              Start Virtual Tour

            </button>

          </div>

          {/* RIGHT SIDE */}
          <div className="flex justify-center">

            <div
              onClick={() =>
                navigate(
                  "/virtual-tour"
                )
              }
              className="relative w-[320px] h-[320px] md:w-[420px] md:h-[420px] rounded-full bg-gradient-to-br from-[#0B4F9C] to-[#072F5F] flex items-center justify-center cursor-pointer shadow-[0_20px_60px_rgba(11,79,156,0.4)] hover:scale-105 transition-all duration-500"
            >

              {/* OUTER RING */}
              <div className="absolute inset-5 rounded-full border-2 border-white/20 animate-pulse"></div>

              {/* INNER CIRCLE */}
              <div className="w-[220px] h-[220px] md:w-[280px] md:h-[280px] rounded-full bg-white flex flex-col items-center justify-center text-center shadow-inner">

                <span className="text-[#0B4F9C] uppercase tracking-[4px] text-sm font-semibold">

                  Click To

                </span>

                <h2 className="text-5xl md:text-7xl font-extrabold text-[#072F5F] leading-none my-3">

                  ENTER

                </h2>

                <span className="text-gray-500 text-lg font-medium">

                  Virtual Tour

                </span>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default HomeVirtualTour;